// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1910) return "static/chunks/4e6af11a-816ade350c01b6ba.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"58":"794308b2dd4a82bc","287":"37994c5e201db5c1","2027":"ee22061fd2e523bb","3280":"d1e18c86268303a6","3828":"b7132362c282fe55","5181":"a90b701ae97f29b2"}[chunkId] + ".js";
};